import { render, staticRenderFns } from "./plCont.vue?vue&type=template&id=635501c3&scoped=true"
import script from "./plCont.vue?vue&type=script&lang=js"
export * from "./plCont.vue?vue&type=script&lang=js"
import style0 from "./plCont.vue?vue&type=style&index=0&id=635501c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635501c3",
  null
  
)

export default component.exports